/**
 * @desc 查询PO/SN码
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<ObjectMap>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSn/searchCode/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
